<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16"> Debug </strong>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <a-input-search
          v-model="email1"
          placeholder="email user 1"
          @search="onSearch1"
        />
      </div>
      <div class="col-lg-6">
        <a-input-search
          v-model="email2"
          placeholder="email user 2"
          @search="onSearch2"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div v-show="Object.keys(detail1).length != 0" class="card">
          <div class="card-body">
            <img
              v-if="detail1.photo || detail1.avatar"
              class="img-card"
              :src="
                detail1.avatar
                  ? detail1.avatar
                  : detail1.photo[0]
                  ? detail1.photo[0]
                  : detail1.photo
              "
            />
            <a-form :layout="formLayout">
              <a-form-item
                v-for="key in Object.keys(detail1)"
                :key="key"
                :label="key"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <span v-if="key == 'created'">{{
                  detail1[key] | formatDate
                }}</span>
                <span v-if="key == 'gender'">{{
                  detail1[key] == 0 ? "Nam" : "Nu"
                }}</span>
                <span v-else>{{ detail1[key] }}</span>
              </a-form-item>
              <a-form-item
                v-if="detail1.location && detail1.location.longitude"
                label=" "
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <iframe
                  width="300"
                  height="170"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                  :src="
                    `https://maps.google.com/maps?q=` +
                    detail1.location.latitude +
                    `,` +
                    detail1.location.longitude +
                    `&hl=es&z=14&amp;output=embed`
                  "
                >
                </iframe>
                <br />
                <small>
                  <a
                    :href="
                      `https://maps.google.com/maps?q=` +
                      detail1.location.latitude +
                      `,` +
                      detail1.location.longitude +
                      `&hl=es;z=14&amp;output=embed`
                    "
                    style="color: #0000ff; text-align: left"
                    target="_blank"
                  >
                    See map bigger
                  </a>
                </small>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div v-show="Object.keys(detail2).length != 0" class="card">
          <div class="card-body">
            <img
              v-if="detail2.photo || detail2.avatar"
              class="img-card"
              :src="
                detail2.avatar
                  ? detail2.avatar
                  : detail2.photo[0]
                  ? detail2.photo[0]
                  : detail2.photo
              "
            />
            <a-form :layout="formLayout">
              <a-form-item
                v-for="key in Object.keys(detail2)"
                :key="key"
                :label="key"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <span v-if="key == 'created'">{{
                  detail2[key] | formatDate
                }}</span>
                <span v-if="key == 'gender'">{{
                  detail2[key] == 0 ? "Nam" : "Nu"
                }}</span>
                <span v-else>{{ detail2[key] }}</span>
              </a-form-item>
              <a-form-item
                v-if="detail2.location && detail2.location.longitude"
                label=" "
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
                <iframe
                  width="300"
                  height="170"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                  :src="
                    `https://maps.google.com/maps?q=` +
                    detail2.location.latitude +
                    `,` +
                    detail2.location.longitude +
                    `&hl=es&z=14&amp;output=embed`
                  "
                >
                </iframe>
                <br />
                <small>
                  <a
                    :href="
                      `https://maps.google.com/maps?q=` +
                      detail2.location.latitude +
                      `,` +
                      detail2.location.longitude +
                      `&hl=es;z=14&amp;output=embed`
                    "
                    style="color: #0000ff; text-align: left"
                    target="_blank"
                  >
                    See map bigger
                  </a>
                </small>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
    </div>
    <div class="button_check">
      <a-button style="width: 150px" @click="clickCheck"
        >check Matching</a-button
      >
    </div>
    <div class="button_check">
      <span>{{ this.message }}</span>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  data() {
    return {
      loading: false,
      email1: "",
      email2: "",
      detail1: {},
      detail2: {},
      formLayout: "horizontal",
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      loading: false,
      coin: "",
      message: "",
    };
  },
  methods: {
    onSearch1(value) {
      this.api("admin/userByEmail?email=" + value).then((res) => {
        this.detail1 = res;
      });
    },
    onSearch2(value) {
      this.api("admin/userByEmail?email=" + value).then((res) => {
        this.detail2 = res;
      });
    },
    clickCheck() {
      if (!this.email1 || !this.email2) {
        return this.$notification.error({
          message: "invalid input",
          description: "input email.",
        });
      }
      this.api("admin/checkMatching", {
        email1: this.email1,
        email2: this.email2,
      }).then((res) => {
        console.log(res);
        if (res.userInfo1) this.detail1 = res.userInfo1;
        else
          this.detail1 = {
            error: "not fond user",
          };
        if (res.userInfo2) this.detail2 = res.userInfo2;
        else
          this.detail2 = {
            error: "not fond user",
          };
        this.message = res.status;
      });
    },
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
          }
        : {};
    },
  },
  mixins: [api, helper],
};
</script>
<style scoped>
.img-card {
  width: 200px;
  position: absolute;
  top: 10px;
  right: 20px;
}
.button_check {
  text-align: center;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
</style>
